import { createTheme } from '@mineral/core';
import { paletteOrange600 } from '@mineral/tokens';
declare module '@mui/material/styles' {
  interface Theme {
    accent: {
      features: string;
      featuresHover: string;
      connectors: string;
      connectorsHover?: string;
      integrations: string;
      cardHover: string;
      deleteConfig: string;
      deleteConfigHover: string;
      duplicateConfig: string;
      duplicateConfigHover: string;
      userColor: string;
      campaigns: string;
      campaignsHover: string;
      integrationsHover?: string;
      disabledColor: string;
      dragging_box_shadow: string;
      activeConfig?: string;
    };
  }

  interface ThemeOptions {
    accent: {
      features?: string;
      featuresHover?: string;
      connectors?: string;
      connectorsHover?: string;
      integrations?: string;
      deleteConfig: string;
      duplicateConfig: string;
      deleteConfigHover: string;
      campaigns: string;
      campaignsHover: string;
      duplicateConfigHover: string;
      cardHover: string;
      userColor: string;
      integrationsHover?: string;
      dragging_box_shadow: string;
      activeConfig?: string;
    };
  }
}

export const themeProps = {
  accent: {
    features: '#007B8C',
    featuresHover: '#044048',
    connectors: '#79242F',
    connectorsHover: '#500710',
    integrations: '#005C8A',
    cardHover: '#F5F5F5',
    userColor: '#551A8B',
    integrationsHover: '#073E59',
    disabledColor: '58606E',
    dragging_box_shadow: '8px 8px 6px 0px #3272D940',
    deleteConfig: '#FF015D',
    deleteConfigHover: '#B73061',
    duplicateConfig: '#FEC000',
    duplicateConfigHover: '#B99834',
    activeConfig: '#E9F0F9',
    campaigns: '#E68C28',
    campaignsHover: paletteOrange600,
  },
};
export const theme = createTheme(themeProps);
